module.exports = __webpack_public_path__ + "img/rs_baby1.8ea0cb65.jpg";